import PropTypes from "prop-types";
import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,

} from "reactstrap";

// Pages Components
import WelcomeComp from "./WelcomeComp";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//redux
import { useSelector, useDispatch } from "react-redux";
import Line from "../AllCharts/echart/linechart"
import LineChart from "../AllCharts/chartjs/linechart"

import {
  getUsers as onGetUsers,
    getSliders as onGetSliders, 
  getNews_Category as onGetNews_Category,
    getForum as onGetForum,

} from "store/contacts/actions";
const Dashboard = props => {
  const dispatch = useDispatch();

  const { users } = useSelector(state => ({
    users: state.contacts.users,
  }));

  
  const { ne } = useSelector(state => ({
    ne: state.contacts.ne,
  }));

    const { sliders } = useSelector(state => ({
    sliders: state.contacts.sliders,
  }));

      const { forum } = useSelector(state => ({
    forum: state.contacts.forum,
  }));

  const reports = [
    { title: "Toplam Üye", iconClass: "bx-archive-in", description: users.length },
       { title: "Toplam Anket", iconClass: "bx-archive-in", description: sliders.length },
              { title: "Toplam Yorum", iconClass: "bx-archive-in", description: ne.length },
              { title: "Toplam Satış", iconClass: "bx-archive-in", description: forum.length },

  ];

    useEffect(() => {
    if (forum && !forum.length) {
      dispatch(onGetForum());
    }
  }, [dispatch, forum]);



  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetUsers());
    }
  }, [dispatch, users]);


    useEffect(() => {
    if (sliders && !sliders.length) {
      dispatch(onGetSliders());
    }
  }, [dispatch, sliders]);

    useEffect(() => {
    if (ne && !ne.length) {
      dispatch(onGetNews_Category());
    }
  }, [dispatch, ne]);

  //meta title
  document.title = "Anasayfa | Oyliyo Admin Paneli";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Yönetim")}
            breadcrumbItem={props.t("Anasayfa")}
          />

          <Row>
            <Col xl="4">
              <WelcomeComp />
            </Col>
            <Col xl="8">
             <Row>
                {/* Reports Render */}
                {reports.map((report, key) => (
                  <Col md="4" key={"_col_" + key}>
                    <Card className="mini-stats-wid">
                    <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                            {report.title}
                            </p>
                            <h4 className="mb-0">{report.description}</h4>
                          </div>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                            <span className="avatar-title rounded-circle bg-primary">
                              <i
                                className={
                                  "bx " + report.iconClass + " font-size-24"
                                }
                              ></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>


                  <div id="line-chart" className="e-chart">
      <Line dataColors='["--bs-success"]' polls={sliders} />
                  </div>


                  <LineChart  users={users} dataColors='["--bs-primary-rgb, 0.2", "--bs-primary", "--bs-light-rgb, 0.2", "--bs-light"]' />


             
            </Col>
          </Row>

        

         
        </Container>
      </div>


    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
